<template>
  <div class="special-fund-details">
    <div class="fund-details-top">
      <div class="fund-details-top-img">
        <!-- <img :src="info.imgUrl" alt="" width="100%"> -->
        <Banner :bannerData="bannerData"></Banner>
      </div>
      <div class="fund-details-top-introduce" :class="{'fund-details-top-introduce-mobile' : isMobile == 'mobile'}">
        <h2>{{ $t('FundIntroduction') }}</h2>
        <!-- <div style="padding: 0 15%;">
          <el-divider></el-divider>
        </div> -->
        <div class="content">
          <div v-html="info.content" style="text-indent:2em;" class="details-content"></div>
        </div>
      </div>
    </div>
    <div>
      <div class="fund-details-bottom">
        <div class="fund-details-bottom-title">
          <div class="title-symbol"></div>
          <h2>{{ $t('NewsInformation') }}</h2>
        </div>
        <div class="fund-details-bottom-news">
          <detailListCard v-for="item in info.articles" :item="item" :key="item.id" :fundId="info.id"></detailListCard>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getSpecFundInfo } from '@/api/index';
import { pageArticleByModuleId } from "@/api/index";
import detailListCard from '../componets/detailListCard.vue'
export default {
  components: {
    detailListCard
  },
  computed:{
    isMobile() {
        const userAgentInfo = navigator.userAgent;
        const agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
        for (let i = 0; i < agents.length; i++) {
            if (userAgentInfo.indexOf(agents[i]) > -1) {
                return 'mobile'; // 移动端
            }
        }
        return 'pc'; // PC端
    }
  },
  data() {
    return {
		fundId:'',
      info: {},
      newsList: [],
      bannerData: [
        {
          title: 'image-1',
          link: 'javascript:;',
          imgUrl: ''
        }
      ],
    }
  },
  methods: {
    async getSpecFundInfo(id) {
      let form = new FormData();
      form.append("id", id);
      let res = await getSpecFundInfo(form)
      if (res.data && res.data != null) {
        this.info = res.data;
		this.bannerData = res.data.bannerList;
		if (res.data.themeColor) {
		  this.$store.commit('updateThemeColor', res.data.themeColor);
		}
		if (res.data.logo) {
		  this.$store.commit('updateFundLog', res.data.logo);
		}
      }
    },
  },
  mounted() {
    const meta = document.createElement('meta');
    meta.setAttribute('name', 'referrer');
    meta.setAttribute('content', 'never');
    document.head.appendChild(meta);
    this.id = this.$route.query.id
    this.getSpecFundInfo(this.id)
  }

}
</script>
<style lang="less" scoped>
.special-fund-details {
  .fund-details-top {
    width: 100%;
    background-color: #fafafb;
    .fund-details-top-img {
    }
    .fund-details-top-introduce {
      z-index: 99;
      width: 100%;
      box-sizing: border-box;
      margin: 0;
      padding: 3rem 10rem;
      background-color: #FEFEFE;
      font-size: 1rem;
      line-height: 2rem;
      font-weight: 600;
      // position: relative;
      // top: -2rem;
      h2 {
        color: #2c4b8e;
        text-align: center;
      }
    }
    .fund-details-top-introduce-mobile{
      width: 100%!important;
      padding: 2rem!important;
    }
  }
  .fund-details-bottom {
    background-color: #f6f6f6;
    width: 75%;
    margin: 3rem auto;
    box-sizing: border-box;
    .fund-details-bottom-title {
      height: 1.5rem;
      line-height: 1.5rem;
      .title-symbol {
        background-color: #2c4b8e;
        width: 1.3rem;
        height: 1.5rem;
        float: left;
        margin-right: 0.5rem;
      }
    }
  }
}
.content {
  font-size: 1rem;
  line-height: 2rem;
}
.details-content {
  display: inline-block;
  overflow: auto;
  width: 100%;
  img {
    width: 100% !important;
  }
}
</style>
<style>
.details-content img {
  width: 100% !important;
  height: auto !important;
}
</style>